import { Component, inject, Input, OnInit } from '@angular/core';

import { TRANSLOCO_SCOPE, TranslocoDirective } from '@ngneat/transloco';

import { inlineLoaderFactory, parsedFreeCancellationDate } from '@rx-applications/shared/utils';
import { InternationalizationService } from '@rx-applications/clientsite/shared/internationalization/data-access';
import { DatePipe, NgIf } from '@angular/common';

@Component({
  selector: 'rx-applications-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  standalone: true,
  imports: [TranslocoDirective, NgIf, DatePipe],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'cancellationPolicy',
        loader: inlineLoaderFactory((lang: string) => import(`./assets/i18n/${lang}.json`)),
      },
    },
  ],
})
export class CancellationPolicyComponent implements OnInit {
  readonly internationalizationService = inject(InternationalizationService);

  @Input() isRefundable = true;
  @Input() gmtTime: string;
  @Input() hotelTime?: string | null;

  refundableKey = 'nonRefundable';
  cancelBeforeDate: Date;

  readonly regionalTimeFormat: string = this.internationalizationService.regionalTimeFormat;

  public ngOnInit(): void {
    if (this.isRefundable) {
      this.refundableKey = this.hotelTime ? 'refundableWithOffset' : 'refundableBefore';
    }
    this.cancelBeforeDate = parsedFreeCancellationDate(this.gmtTime, this.hotelTime);
  }
}
